import React from 'react';
import clsx from 'clsx';

export default function Page(props: any) {
  return (
    <div className={clsx(props.className, "content")}>
      {props.children}
    </div>
  );
}



